import { TipoValorEnum } from '@core/enums';
import { IIntegerPrecisionService } from '@core/interfaces/integer-precision-service.interface';
import { DeliveryZone, WorkDay } from '@core/models';

export function calculateDeliveryCharge(
	deliveryZone: DeliveryZone | null,
	subtotal: bigint,
	precisionService: IIntegerPrecisionService,
	workDay: WorkDay
): bigint {
	if (!deliveryZone) return 0n;

	switch (deliveryZone.tipoTarifa) {
		case TipoValorEnum.Porcentaje: {
			const { tax: deliveryCharge } = precisionService.adjustTaxFromScaledValue(
				subtotal,
				Number(deliveryZone?.tarifa),
				false,
				workDay
			);

			return precisionService.changePrecisionToInternal(
				precisionService.toScaledStringVisual(deliveryCharge, workDay),
				precisionService.visualPrecision,
				workDay
			);
		}
		case TipoValorEnum.Dolar:
			return BigInt(deliveryZone.tarifa ?? 0);
		default:
			return BigInt(deliveryZone.tarifa ?? 0);
	}
}
